import { useRef } from 'react';
import { createPortal } from 'react-dom';
import type { Maybe } from 'yup';

import { VideoPlayerBase } from './VideoPlayerBase';

import * as S from './VideoPlayer.styles';

interface VideoProps {
  isCountDownType?: boolean;
  isPopupMode?: boolean;
  localeCode?: string;
  mediaUrl: Maybe<string>;
  onClose?: () => void;
  playOption?: string;
  poster?: string;
  title?: Maybe<string>;
}

export const VideoPlayer = ({
  playOption = 'AutoplayLoop',
  ...restProps
}: VideoProps) => {
  const modalTargetElement = useRef<HTMLElement | null>(null);
  modalTargetElement.current = document.getElementById('modal-root');

  if (!restProps.mediaUrl || !modalTargetElement.current) return null;

  return createPortal(
    <S.VideoModal data-testid='VideoVideoModal'>
      <VideoPlayerBase playOption={playOption} {...restProps} />
    </S.VideoModal>,
    modalTargetElement.current,
  );
};
